import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import BrandStyleSheet from "./BrandStyleSheet";

class WindcavePolling extends Component {
  state = {
    propertyUid: null,
    bookingNumber: null,
    presets: {},
    itemWithRelHppUrl: "",
    countryCode: "US",
    language: "US",
    pathname: null,
  };

  componentDidMount() {
    const {
      propertyUid,
      itemWithRelHppUrl,
      bookingNumber,
      language,
      presets,
      pathname,
    } = this.props.location.state;
    this.setState({
      propertyUid,
      bookingNumber,
      language,
      presets,
      itemWithRelHppUrl,
      pathname,
    });
  }

  goBack() {
    this.props.history.push(this.state.pathname);
  }

  render() {
    const { presets, property, itemWithRelHppUrl } = this.state;
    const primaryColor =
      (property && property.primary_color) || "rgb(46, 30, 24)";
    const appTopNavBgColor =
      (presets && presets.app_top_nav_bg_color) || primaryColor;
    const appHomeTextTopNav =
      (presets && presets.app_home_text_top_nav) || primaryColor;

    return (
      <>
        <div className="h-full flex flex-col w-full">
          <BrandStyleSheet brandStyleSheet={presets.app_brand_stylesheet} />
          <div className="flex flex-col h-full">
            <section
              id="header"
              className="w-full sticky top-0 z-10">
              <div
                className="flex py-8 px-4 text-white text-left cursor-pointer"
                style={{ backgroundColor: appTopNavBgColor }}
                onClick={() => this.goBack()}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill={appHomeTextTopNav}
                  viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
                <span
                  className="pl-4 type-title large"
                  style={{ color: appHomeTextTopNav }}>
                  Windcave Payment
                </span>
              </div>
            </section>

            <section
              id="content"
              className="relative px-9 w-full flex-1 md:flex-0 flex flex-col justify-between h-screen">
              <main
                className="main container h-full"
                style={{ marginTop: "15px" }}>
                <section className="checkout relative h-full">
                  <iframe
                    title="windcave"
                    src={itemWithRelHppUrl}
                    frameBorder="0"
                    scrolling="auto"
                    allowFullScreen={true}
                    className="w-full aspect-auto absolute inset-0"
                    width="100%"
                    height="100%"></iframe>
                </section>
              </main>
            </section>
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(WindcavePolling);
